import { onMounted, ref } from "@vue/composition-api";
import { AxiosResponse } from "axios";

type Request<T> = { (): Promise<AxiosResponse<T>> };
type Config = {
  /**
   * 初回にリクエストを走らせるか
   */
  immediate?: boolean;
};

export const useRequest = <T>(
  defaultRequest?: Request<T>,
  { immediate = false }: Config = {}
) => {
  const data = ref<T>();
  const status = ref<number>();
  const error = ref<unknown>();
  const loading = ref<boolean>();

  const runRequest = async (request?: Request<T>) => {
    if (!defaultRequest && !request) {
      return;
    }

    loading.value = true;
    try {
      const response = request ? await request() : await defaultRequest!();
      data.value = response.data;
      status.value = response.status;
      error.value = undefined;
    } catch (e) {
      error.value = e;
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    if (immediate) {
      runRequest();
    }
  });

  return [
    {
      data,
      status,
      error,
      loading
    },
    runRequest
  ] as const;
};
